import React from 'react'
import { Breadcrumbs as MUIBreadcrumbs, Link, Stack } from '@mui/material'
import { useAppSelector } from '../redux/hooks'
import { RootState } from '../redux/rootReducer'
import { useTheme } from '@mui/material/styles'
import Iconify from './Iconify'

export function Breadcrumbs () {
  const { palette } = useTheme()
  const { breadcrumb } = useAppSelector((state: RootState) => state.breadcrumb)

  return (
    <Stack py={2} px={1}>
      <MUIBreadcrumbs
        aria-label="breadcrumb"
        separator={<Iconify icon="mingcute:right-line" color={palette.grey[500]}/>}>
        {breadcrumb.map(({ label, path }, key) => {
          if (breadcrumb.length === key + 1) {
            return <Link variant="subtitle1" underline="none" color={palette.primary.main} key={key}>
              {label}
            </Link>
          }
          return <Link variant="subtitle1" underline="none" color="text.primary" href={path} key={key}>
            {label}
          </Link>
        })}
      </MUIBreadcrumbs>
    </Stack>
  )
}
